import { MediaModel, OrgModel } from '@utmost.co/enterprise-models';
import { MediaModel as MediaModelV2, OrgModel as OrgModelV2 } from '@utmost.co/enterprise-models';
import defaultAvatarUrl from 'src/static/images/default-org-avatar.svg';
import { randomString } from './RandomString';

export const buildMediaPicUri = (
  resource?: DeepMaybe<Pick<Partial<MediaModel | MediaModelV2>, 'uid'>>,
  cacheBust = false
) =>
  resource?.uid
    ? `/api/media/${resource.uid}/content${cacheBust ? `?cacheBust=${randomString()}` : ''}`
    : defaultAvatarUrl;

export const getExternalIdValue = (org: DeepMaybe<OrgModel> | DeepMaybe<OrgModelV2>, showCode: boolean) => {
  if (!showCode) {
    return undefined;
  }

  if (org?.referenceCode) {
    return org?.referenceCode;
  }

  if (org?.referenceId) {
    return org?.referenceId;
  }

  return org?.wid ?? undefined;
};
